import { Fragment } from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  LinearProgress,
  Divider,
  Typography,
} from "@mui/material";
import AirportIcon from "@mui/icons-material/FlightTakeoff";

export function TopAirportsList({ topAirports }) {
  const maxCount = Math.max(...topAirports.map((a) => a.count));

  return (
    <List disablePadding sx={{ width: "95%" }}>
      {topAirports.map((a, i) => {
        const percent = Math.round((a.count / maxCount) * 100);
        return (
          <Fragment key={a.name}>
            <ListItem
              sx={{
                alignItems: "flex-start",
                "&:hover": { background: "#f5f5f5" },
                px: 0,
                py: 1,
              }}
            >
              <ListItemAvatar
                sx={{
                  display: "flex",
                  justifySelf: "start",
                  alignSelf: "center",
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: "var(--color-primary)",
                    width: 32,
                    height: 32,
                  }}
                >
                  {/* <AirportIcon fontSize="small" /> */}
                  {a.count.toLocaleString()}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: "1.1rem",
                      mb: 0.25,
                      lineHeight: "0.8rem",
                      letterSpacing: 1,
                    }}
                  >
                    {a.name}
                  </Typography>
                }
                secondary={
                  <>
                    {/* <Typography
                      variant="caption"
                      color="textSecondary"
                      sx={{
                        fontWeight: 500,
                        fontSize: "0.9rem",
                        lineHeight: "0.8rem",
                        letterSpacing: 1,
                        display: "block",
                      }}
                    >
                      {a.count.toLocaleString()} connections
                    </Typography> */}
                    <LinearProgress
                      variant="determinate"
                      value={percent}
                      sx={{
                        height: 6,
                        borderRadius: 3,
                        mt: 0.5,
                        backgroundColor: "#e0e0e0",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "var(--color-primary)",
                        },
                      }}
                    />
                  </>
                }
              />
            </ListItem>
            {i < topAirports.length - 1 && (
              <Divider component="li" variant="inset" />
            )}
          </Fragment>
        );
      })}
    </List>
  );
}
